import 'swiper/css/swiper.css'
import '@/plugins/bootstrap'

import Vue from 'vue'
import VueLanding from 'nespresso-components/landing/VueLanding'
import Tracking from 'nespresso-library/src/core/tracking'

import App from '@/components/LandingView.vue'

if (process.env.NODE_ENV === 'development') {
    Vue.config.performance = true
    Vue.config.devtools = true
    Vue.config.productionTip = true
}

export const main = () => {
    const trackingLabel = 'B2B - Hygiene'
    Vue.use(VueLanding, {
        project: 'b2b-hygiene',
        landing: 'Hygiene',
        centralLandingAlias: 'Hygiene',
        trackingLabelPrefix: trackingLabel,
        skipMutationKeys: [
            'background',
            'capsules',
            'image',
            'responsiveImages',
            'standard',
            'sizes'
        ],
        sectionTrackingLabels: {
            safety: 'Safety',
            dispenser: 'Dispenser',
            app: 'App',
            environment: 'Environment'
        }
    })
    Tracking.globalTracking(trackingLabel)
    return new Vue({
        el: '#agilityApp',
        render: h => h(App)
    })
}

main()
